import { useState, useEffect, useMemo, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  EMPTY_INVENTORY_FILTERS,
  fetchInventoryCars,
  fetchInventoryFilters,
  type InventoryCarItem,
  type InventoryFilters,
  type InventoryPagination,
} from "@/data/carsData";
import {
  Search,
  Grid3X3,
  List,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  X,
  ArrowRight,
  Star,
  Shield,
  CreditCard,
  Car,
  Gauge,
  Settings,
  Settings2,
  Fuel,
  ChevronUp,
  Filter,
} from "lucide-react";
import { Slider } from "@/components/ui/slider";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
import "./CarInventory.css";

// // Car data
// const carsData = [
//   {
//     id: 1,
//     year: 2019,
//     make: "Honda",
//     model: "Civic",
//     trim: "LX",
//     image: "/images/car-civic-2019.jpeg",
//     price: 17999,
//     weeklyPayment: 83,
//     bodyStyle: "Sedan",
//     transmission: "Automatic",
//     stockNumber: "HN19-209",
//     isGoodPrice: true,
//     km: 160000,
//     vin: "2HGFC2F69KH123456",
//     engine: "4 Cylinder Engine",
//     fuelType: "Gas",
//     exteriorColor: "Black",
//     drivetrain: "FWD",
//     passengers: 5,
//     cylinders: 4,
//     condition: "Used",
//   },
//   {
//     id: 2,
//     year: 2014,
//     make: "BMW",
//     model: "528i",
//     trim: "Luxury",
//     image: "/images/car-bmw-2014.jpeg",
//     price: 13999,
//     weeklyPayment: 265,
//     bodyStyle: "Sedan",
//     transmission: "8 Speed Automatic",
//     stockNumber: "BM22-089",
//     isGoodPrice: false,
//     km: 98750,
//     vin: "WBA5A5C55ED123456",
//     engine: "4 Cylinder Engine",
//     fuelType: "Gas",
//     exteriorColor: "Black",
//     drivetrain: "RWD",
//     passengers: 5,
//     cylinders: 4,
//     condition: "Used",
//   },
//   {
//     id: 3,
//     year: 2019,
//     make: "KIA",
//     model: "Sedona",
//     trim: "LX+",
//     image: "/images/car-sedona-2019.jpeg",
//     price: 14999,
//     weeklyPayment: 88,
//     bodyStyle: "Minivan",
//     transmission: "6 Speed Automatic",
//     stockNumber: "S17-135",
//     isGoodPrice: false,
//     km: 67800,
//     vin: "KNDMB5C15K1234567",
//     engine: "6 Cylinder Engine",
//     fuelType: "Gas",
//     exteriorColor: "White",
//     drivetrain: "FWD",
//     passengers: 7,
//     cylinders: 6,
//     condition: "Used",
//   },
//   {
//     id: 4,
//     year: 2018,
//     make: "Toyota",
//     model: "Corolla",
//     trim: "LE",
//     image: "/images/car-corolla-2018.jpeg",
//     price: 18500,
//     weeklyPayment: 179,
//     bodyStyle: "Sedan",
//     transmission: "6 Speed Automatic",
//     stockNumber: "WB23-040",
//     isGoodPrice: true,
//     km: 38900,
//     vin: "2T1BURHE8JC123456",
//     engine: "4 Cylinder Engine",
//     fuelType: "Gas",
//     exteriorColor: "Grey",
//     drivetrain: "FWD",
//     passengers: 5,
//     cylinders: 4,
//     condition: "Used",
//   },
//   {
//     id: 5,
//     year: 2021,
//     make: "Hyundai",
//     model: "Elantra Preffered",
//     trim: "Preferred",
//     image: "/images/car-elantara-2021.jpeg",
//     price: 19500,
//     weeklyPayment: 166,
//     bodyStyle: "Sedan",
//     transmission: "CVT Automatic",
//     stockNumber: "HY21-204",
//     isGoodPrice: true,
//     km: 95000,
//     vin: "KMHLM4AG5MU123456",
//     engine: "4 Cylinder Engine",
//     fuelType: "Gas",
//     exteriorColor: "White",
//     drivetrain: "FWD",
//     passengers: 5,
//     cylinders: 4,
//     condition: "Used",
//   },
//   {
//     id: 6,
//     year: 2021,
//     make: "Hyundai",
//     model: "Sonata",
//     trim: "Preferred",
//     image: "/images/car-sonata-2021.jpeg",
//     price: 19500,
//     weeklyPayment: 83,
//     bodyStyle: "Sedan",
//     transmission: "Automatic",
//     stockNumber: "HY21-206",
//     isGoodPrice: true,
//     km: 62000,
//     vin: "5NPEH4J26MH123456",
//     engine: "4 Cylinder Engine",
//     fuelType: "Gas",
//     exteriorColor: "White",
//     drivetrain: "FWD",
//     passengers: 5,
//     cylinders: 4,
//     condition: "Used",
//   },
//   {
//     id: 7,
//     year: 2019,
//     make: "Volkswagen",
//     model: "Jetta",
//     trim: "Highline",
//     image: "/images/car-jetta-2019.jpeg",
//     price: 17999,
//     weeklyPayment: 83,
//     bodyStyle: "Sedan",
//     transmission: "Automatic",
//     stockNumber: "VW19-207",
//     isGoodPrice: true,
//     km: 70000,
//     vin: "3VWG57BU1KM123456",
//     engine: "4 Cylinder Engine",
//     fuelType: "Gas",
//     exteriorColor: "White",
//     drivetrain: "FWD",
//     passengers: 5,
//     cylinders: 4,
//     condition: "Used",
//   },
//   {
//     id: 8,
//     year: 2025,
//     make: "Hyundai",
//     model: "Elantra",
//     trim: "Preferred",
//     image: "/images/car-elantra-2025.jpeg",
//     price: 25500,
//     weeklyPayment: 99.5,
//     bodyStyle: "Sedan",
//     transmission: "Automatic",
//     stockNumber: "HY25-208",
//     isGoodPrice: true,
//     km: 36000,
//     vin: "KMHLM4DGXSU123456",
//     engine: "4 Cylinder Engine",
//     fuelType: "Gas",
//     exteriorColor: "Grey",
//     drivetrain: "FWD",
//     passengers: 5,
//     cylinders: 4,
//     condition: "Used",
//   },
// ];

const CURRENT_YEAR = new Date().getFullYear();
const DEFAULT_PRICE: [number, number] = [0, 150000];
const DEFAULT_PAYMENT: [number, number] = [0, 300];
const DEFAULT_YEAR: [number, number] = [2010, CURRENT_YEAR];
const DEFAULT_KM: [number, number] = [0, 200000];
const INVENTORY_PAGE_SIZE = 20;

// Scroll reveal hook
function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" },
    );

    document.querySelectorAll(".scroll-reveal").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);
}

const clampBetween = (value: number, min: number, max: number) =>
  Math.min(Math.max(value, min), max);

const getQueryArray = (params: URLSearchParams, key: string): string[] => {
  const repeatedValues = params
    .getAll(key)
    .map((value) => value.trim())
    .filter(Boolean);

  if (repeatedValues.length > 0) {
    return Array.from(new Set(repeatedValues));
  }

  const singleValue = params.get(key)?.trim() ?? "";
  if (!singleValue) return [];

  return Array.from(
    new Set(
      singleValue
        .split(",")
        .map((value) => value.trim())
        .filter(Boolean),
    ),
  );
};

const getQueryNumber = (
  params: URLSearchParams,
  key: string,
): number | null => {
  const rawValue = params.get(key);

  if (rawValue === null || rawValue.trim() === "") return null;

  const parsed = Number(rawValue);
  return Number.isFinite(parsed) ? parsed : null;
};

export default function CarInventory() {
  useScrollReveal();

  const location = useLocation();

  const navigate = useNavigate();

  const [viewMode, setViewMode] = useState<"grid" | "list">("grid");
  const [sortBy, setSortBy] = useState("make-asc");
  const [keywordSearch, setKeywordSearch] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const [inventoryCars, setInventoryCars] = useState<InventoryCarItem[]>([]);
  const [inventoryLoading, setInventoryLoading] = useState(true);

  const [inventoryError, setInventoryError] = useState("");
  const [inventoryPagination, setInventoryPagination] =
    useState<InventoryPagination>({
      page: 1,
      limit: INVENTORY_PAGE_SIZE,
      total: 0,
      totalPages: 1,
    });
  const [filterOptions, setFilterOptions] = useState<InventoryFilters>(
    EMPTY_INVENTORY_FILTERS,
  );
  const [currentPage, setCurrentPage] = useState(1);

  const [priceFilterMode, setPriceFilterMode] = useState<"price" | "payment">(
    "price",
  );
  const [priceRange, setPriceRange] = useState<[number, number]>(DEFAULT_PRICE);
  const [priceRangeDraft, setPriceRangeDraft] =
    useState<[number, number]>(DEFAULT_PRICE);

  const [paymentRange, setPaymentRange] =
    useState<[number, number]>(DEFAULT_PAYMENT);
  const [paymentRangeDraft, setPaymentRangeDraft] =
    useState<[number, number]>(DEFAULT_PAYMENT);

  const [yearRange, setYearRange] = useState<[number, number]>(DEFAULT_YEAR);
  const [yearRangeDraft, setYearRangeDraft] =
    useState<[number, number]>(DEFAULT_YEAR);

  const [kmRange, setKmRange] = useState<[number, number]>(DEFAULT_KM);
  const [kmRangeDraft, setKmRangeDraft] =
    useState<[number, number]>(DEFAULT_KM);

  const [selectedConditions, setSelectedConditions] = useState<string[]>([]);
  const [selectedMakes, setSelectedMakes] = useState<string[]>([]);
  const [selectedModels, setSelectedModels] = useState<string[]>([]);

  const [selectedBodyStyles, setSelectedBodyStyles] = useState<string[]>([]);
  const [selectedTransmissions, setSelectedTransmissions] = useState<string[]>(
    [],
  );
  const [selectedColors, setSelectedColors] = useState<string[]>([]);
  const [selectedFuelTypes, setSelectedFuelTypes] = useState<string[]>([]);

  const [selectedDrivetrains, setSelectedDrivetrains] = useState<string[]>([]);
  const [selectedCylinders, setSelectedCylinders] = useState<string[]>([]);
  const [selectedPassengers, setSelectedPassengers] = useState<string[]>([]);

  type CarItem = InventoryCarItem;

  const [selectedCompareCars, setSelectedCompareCars] = useState<string[]>([]);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [cardsAnimationClass, setCardsAnimationClass] = useState("");
  const [isPaginating, setIsPaginating] = useState(false);

  const cardsAnimationTimeoutRef = useRef<number | null>(null);
  const paginationRequestRef = useRef(false);
  const paginationDirectionRef = useRef<"next" | "prev">("next");
  const hasRenderedCarsRef = useRef(false);
  const inventoryStartRef = useRef<HTMLDivElement | null>(null);
  const hasMountedFilterScrollRef = useRef(false);

  const scrollToInventoryStart = (behavior: ScrollBehavior = "smooth") => {
    if (!inventoryStartRef.current) return;

    const headerOffset = 120;
    const targetTop =
      inventoryStartRef.current.getBoundingClientRect().top +
      window.scrollY -
      headerOffset;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior,
    });
  };

  useEffect(() => {
    let isMounted = true;

    const loadInventoryFilters = async () => {
      try {
        const apiFilters = await fetchInventoryFilters();
        if (!isMounted) return;
        setFilterOptions(apiFilters);
      } catch {
        if (!isMounted) return;
        setFilterOptions(EMPTY_INVENTORY_FILTERS);
      }
    };

    loadInventoryFilters();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const nextKeyword = params.get("keyword")?.trim() ?? "";

    const nextConditions = getQueryArray(params, "condition");
    const nextMakes = getQueryArray(params, "make");
    const nextModels = getQueryArray(params, "model");
    const nextBodyStyles = getQueryArray(params, "bodyStyle");
    const nextTransmissions = getQueryArray(params, "transmission");
    const nextColors = getQueryArray(params, "color");
    const nextFuelTypes = getQueryArray(params, "fuelType");
    const nextDrivetrains = getQueryArray(params, "drivetrain");
    const nextCylinders = getQueryArray(params, "cylinders");
    const nextPassengers = getQueryArray(params, "passengers");

    let nextPriceMin = getQueryNumber(params, "priceMin");
    let nextPriceMax = getQueryNumber(params, "priceMax");
    let nextYearMin = getQueryNumber(params, "yearMin");
    let nextYearMax = getQueryNumber(params, "yearMax");
    let nextKmMin = getQueryNumber(params, "kmMin");
    let nextKmMax = getQueryNumber(params, "kmMax");

    nextPriceMin = clampBetween(
      nextPriceMin ?? DEFAULT_PRICE[0],
      DEFAULT_PRICE[0],
      DEFAULT_PRICE[1],
    );
    nextPriceMax = clampBetween(
      nextPriceMax ?? DEFAULT_PRICE[1],
      DEFAULT_PRICE[0],
      DEFAULT_PRICE[1],
    );

    nextYearMin = clampBetween(
      nextYearMin ?? DEFAULT_YEAR[0],
      DEFAULT_YEAR[0],
      DEFAULT_YEAR[1],
    );
    nextYearMax = clampBetween(
      nextYearMax ?? DEFAULT_YEAR[1],
      DEFAULT_YEAR[0],
      DEFAULT_YEAR[1],
    );

    nextKmMin = clampBetween(
      nextKmMin ?? DEFAULT_KM[0],
      DEFAULT_KM[0],
      DEFAULT_KM[1],
    );
    nextKmMax = clampBetween(
      nextKmMax ?? DEFAULT_KM[1],
      DEFAULT_KM[0],
      DEFAULT_KM[1],
    );

    if (nextPriceMin > nextPriceMax) {
      nextPriceMin = DEFAULT_PRICE[0];
      nextPriceMax = DEFAULT_PRICE[1];
    }

    if (nextYearMin > nextYearMax) {
      nextYearMin = DEFAULT_YEAR[0];
      nextYearMax = DEFAULT_YEAR[1];
    }

    if (nextKmMin > nextKmMax) {
      nextKmMin = DEFAULT_KM[0];
      nextKmMax = DEFAULT_KM[1];
    }

    const resolvedPriceRange: [number, number] = [nextPriceMin, nextPriceMax];
    const resolvedYearRange: [number, number] = [nextYearMin, nextYearMax];
    const resolvedKmRange: [number, number] = [nextKmMin, nextKmMax];

    setKeywordSearch(nextKeyword);

    setSelectedConditions(nextConditions);
    setSelectedMakes(nextMakes);
    setSelectedModels(nextModels);
    setSelectedBodyStyles(nextBodyStyles);
    setSelectedTransmissions(nextTransmissions);
    setSelectedColors(nextColors);
    setSelectedFuelTypes(nextFuelTypes);
    setSelectedDrivetrains(nextDrivetrains);
    setSelectedCylinders(nextCylinders);
    setSelectedPassengers(nextPassengers);

    setPriceFilterMode("price");
    setPriceRange(resolvedPriceRange);
    setPriceRangeDraft(resolvedPriceRange);

    setYearRange(resolvedYearRange);
    setYearRangeDraft(resolvedYearRange);

    setKmRange(resolvedKmRange);
    setKmRangeDraft(resolvedKmRange);

    setCurrentPage(1);
  }, [location.search]);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    keywordSearch,
    priceFilterMode,
    priceRange,
    paymentRange,
    yearRange,
    kmRange,
    selectedConditions,
    selectedMakes,
    selectedModels,
    selectedBodyStyles,
    selectedTransmissions,
    selectedColors,
    selectedFuelTypes,
    selectedDrivetrains,
    selectedCylinders,
    selectedPassengers,
  ]);

  useEffect(() => {
    if (!hasMountedFilterScrollRef.current) {
      hasMountedFilterScrollRef.current = true;
      return;
    }

    scrollToInventoryStart("smooth");
  }, [
    keywordSearch,
    priceFilterMode,
    priceRange,
    paymentRange,
    yearRange,
    kmRange,
    selectedConditions,
    selectedMakes,
    selectedModels,
    selectedBodyStyles,
    selectedTransmissions,
    selectedColors,
    selectedFuelTypes,
    selectedDrivetrains,
    selectedCylinders,
    selectedPassengers,
  ]);

  useEffect(() => {
    setSelectedCompareCars((prev) => {
      const next = prev.filter((id) =>
        inventoryCars.some((item) => item.id === id),
      );

      return next.length === prev.length ? prev : next;
    });
  }, [inventoryCars]);

  useEffect(() => {
    return () => {
      if (cardsAnimationTimeoutRef.current) {
        window.clearTimeout(cardsAnimationTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    const isCompactScreen =
      typeof window !== "undefined" &&
      window.matchMedia("(max-width: 767.98px)").matches;

    const preserveCardsDuringPagination =
      paginationRequestRef.current &&
      !isCompactScreen &&
      hasRenderedCarsRef.current;

    const loadInventoryCars = async () => {
      try {
        if (!preserveCardsDuringPagination) {
          setInventoryLoading(true);
        }

        setInventoryError("");

        const result = await fetchInventoryCars({
          page: currentPage,
          limit: INVENTORY_PAGE_SIZE,
          keyword: keywordSearch,
          conditions: selectedConditions,
          brands: selectedMakes,
          models: selectedModels,
          bodyStyles: selectedBodyStyles,
          transmissions: selectedTransmissions,
          colors: selectedColors,
          fuelTypes: selectedFuelTypes,
          drivetrains: selectedDrivetrains,
          cylinders: selectedCylinders,
          passengers: selectedPassengers,
          priceMin: priceFilterMode === "price" ? priceRange[0] : undefined,
          priceMax: priceFilterMode === "price" ? priceRange[1] : undefined,
          yearMin: yearRange[0],
          yearMax: yearRange[1],
          kmMin: kmRange[0],
          kmMax: kmRange[1],
          ordBy: 2,
        });

        if (!isMounted) return;

        setInventoryCars(result.cars);
        setInventoryPagination(result.pagination);
        hasRenderedCarsRef.current = result.cars.length > 0;

        if (preserveCardsDuringPagination) {
          if (cardsAnimationTimeoutRef.current) {
            window.clearTimeout(cardsAnimationTimeoutRef.current);
          }

          setCardsAnimationClass("");

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              if (!isMounted) return;

              setCardsAnimationClass(
                paginationDirectionRef.current === "next"
                  ? "inventory-cards-stage--slide-next"
                  : "inventory-cards-stage--slide-prev",
              );
            });
          });

          cardsAnimationTimeoutRef.current = window.setTimeout(() => {
            if (isMounted) {
              setCardsAnimationClass("");
            }
          }, 520);
        }
      } catch (error) {
        if (!isMounted) return;

        if (!preserveCardsDuringPagination) {
          setInventoryCars([]);
          setInventoryPagination({
            page: 1,
            limit: INVENTORY_PAGE_SIZE,
            total: 0,
            totalPages: 1,
          });
          hasRenderedCarsRef.current = false;
        }

        setInventoryError(
          error instanceof Error
            ? error.message
            : "Unable to load inventory data.",
        );
      } finally {
        paginationRequestRef.current = false;

        if (isMounted) {
          setIsPaginating(false);

          if (!preserveCardsDuringPagination) {
            setInventoryLoading(false);
          }
        }
      }
    };

    loadInventoryCars();

    return () => {
      isMounted = false;
    };
  }, [
    currentPage,
    keywordSearch,
    priceFilterMode,
    priceRange,
    yearRange,
    kmRange,
    selectedConditions,
    selectedMakes,
    selectedModels,
    selectedBodyStyles,
    selectedTransmissions,
    selectedColors,
    selectedFuelTypes,
    selectedDrivetrains,
    selectedCylinders,
    selectedPassengers,
  ]);

  const getCarTitle = (car: CarItem) =>
    [car.year ? String(car.year) : "", car.make, car.model, car.trim]
      .filter(Boolean)
      .join(" ");

  const formatNumber = (value: number | null) =>
    value === null ? "" : value.toLocaleString();

  const formatCurrency = (value: number | null) =>
    value === null ? "" : value.toLocaleString();

  const getInstallmentHeading = (type?: string) => {
    const cleaned = type?.trim() ?? "";
    if (!cleaned) return "";
    return `Est. ${cleaned.replace(/^by\s+/i, "")}`;
  };

  const getInstallmentSuffix = (type?: string) => {
    const normalized = type?.trim().toLowerCase() ?? "";

    if (!normalized) return "";
    if (normalized.includes("week")) return "/wk";
    if (normalized.includes("month")) return "/mo";
    if (normalized.includes("day")) return "/day";
    if (normalized.includes("year")) return "/yr";

    return "";
  };

  const getInstallmentMeta = (
    percentage?: string,
    duration?: number | null,
  ) => {
    const pct = percentage?.trim() ?? "";
    const dur = duration ?? null;

    if (pct && dur !== null) return `${pct}% for ${dur} months`;
    if (pct) return `${pct}%`;
    if (dur !== null) return `${dur}`;
    return "";
  };

  const getOptionLabel = (
    options: { value: string; label: string }[],
    value: string,
  ) => options.find((option) => option.value === value)?.label ?? value;

  const selectedCompareCarsData = useMemo<CarItem[]>(
    () =>
      selectedCompareCars
        .map((id) => inventoryCars.find((car) => car.id === id))
        .filter((car): car is CarItem => Boolean(car)),
    [selectedCompareCars, inventoryCars],
  );

  const compareDockVisible = selectedCompareCarsData.length > 0;
  const compareLink = `/compare?cars=${selectedCompareCars.join(",")}`;
  // ↑ replace /compare with your real compare page route if different

  const handleCompareToggle = (carId: string) => {
    setSelectedCompareCars((prev) => {
      if (prev.includes(carId)) {
        return prev.filter((id) => id !== carId);
      }

      if (prev.length >= 2) {
        return prev; // hard limit: only 2 vehicles
      }

      return [...prev, carId];
    });
  };

  const removeComparedCar = (carId: string) => {
    setSelectedCompareCars((prev) => prev.filter((id) => id !== carId));
  };

  const totalPages = Math.max(1, inventoryPagination.totalPages || 1);

  const prevPage = currentPage > 1 ? currentPage - 1 : null;
  const nextPage = currentPage < totalPages ? currentPage + 1 : null;

  const handlePageChange = (page: number) => {
    const nextPage = Math.max(1, Math.min(page, totalPages));

    if (nextPage === currentPage || isPaginating) return;

    paginationRequestRef.current = true;
    paginationDirectionRef.current = nextPage > currentPage ? "next" : "prev";
    setIsPaginating(true);
    setCurrentPage(nextPage);
  };

  useEffect(() => {
    if (!paginationRequestRef.current) return;
    scrollToInventoryStart("smooth");
  }, [currentPage]);

  const toggleInList = (
    value: string,
    setter: React.Dispatch<React.SetStateAction<string[]>>,
  ) => {
    setter((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    );
  };

  // State -> URL

  useEffect(() => {
    const onScroll = () => {
      setShowScrollTop(window.scrollY > 320);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const visibleCars = useMemo(() => {
    const result = [...inventoryCars];

    switch (sortBy) {
      case "price-asc":
        result.sort(
          (a, b) =>
            (a.price ?? Number.MAX_SAFE_INTEGER) -
            (b.price ?? Number.MAX_SAFE_INTEGER),
        );
        break;
      case "price-desc":
        result.sort((a, b) => (b.price ?? -1) - (a.price ?? -1));
        break;
      case "year-asc":
        result.sort((a, b) => a.year - b.year);
        break;
      case "year-desc":
        result.sort((a, b) => b.year - a.year);
        break;
      case "make-asc":
        result.sort((a, b) =>
          `${a.make} ${a.model}`.localeCompare(`${b.make} ${b.model}`),
        );
        break;
      case "make-desc":
        result.sort((a, b) =>
          `${b.make} ${b.model}`.localeCompare(`${a.make} ${a.model}`),
        );
        break;
      case "km-asc":
        result.sort(
          (a, b) =>
            (a.km ?? Number.MAX_SAFE_INTEGER) -
            (b.km ?? Number.MAX_SAFE_INTEGER),
        );
        break;
      case "km-desc":
        result.sort((a, b) => (b.km ?? -1) - (a.km ?? -1));
        break;
      default:
        break;
    }

    return result;
  }, [inventoryCars, sortBy]);

  const conditionOptions = filterOptions.conditions;
  const makeOptions = filterOptions.makes;
  const modelOptions = filterOptions.models;
  const filteredModelOptions = useMemo(() => {
    if (selectedMakes.length === 0) return modelOptions;

    return modelOptions.filter(
      (model) => !model.brandId || selectedMakes.includes(model.brandId),
    );
  }, [modelOptions, selectedMakes]);
  const bodyStyleOptions = filterOptions.bodyStyles;
  const transmissionOptions = filterOptions.transmissions;
  const colorOptions = filterOptions.colors;
  const fuelTypeOptions = filterOptions.fuelTypes;
  const drivetrainOptions = filterOptions.drivetrains;
  const cylindersOptions = filterOptions.cylindersOptions;
  const passengersOptions = filterOptions.passengersOptions;

  const makeCounts = {} as Record<string, number>;

  const toggleMake = (makeValue: string) => {
    setSelectedMakes((prev) =>
      prev.includes(makeValue)
        ? prev.filter((m) => m !== makeValue)
        : [...prev, makeValue],
    );
  };

  const toggleModel = (modelValue: string) => {
    setSelectedModels((prev) =>
      prev.includes(modelValue)
        ? prev.filter((m) => m !== modelValue)
        : [...prev, modelValue],
    );
  };

  useEffect(() => {
    if (selectedMakes.length === 0) return;

    const filteredModelValues = new Set(
      filteredModelOptions.map((model) => model.value),
    );

    setSelectedModels((prev) => {
      const next = prev.filter((modelValue) =>
        filteredModelValues.has(modelValue),
      );

      return next.length === prev.length ? prev : next;
    });
  }, [filteredModelOptions, selectedMakes.length]);

  const activeFilters = [
    ...selectedConditions.map((v) => ({
      type: "condition",
      value: v,
      label: getOptionLabel(conditionOptions, v),
    })),
    ...selectedMakes.map((v) => ({
      type: "make",
      value: v,
      label: getOptionLabel(makeOptions, v),
    })),
    ...selectedModels.map((v) => ({
      type: "model",
      value: v,
      label: getOptionLabel(modelOptions, v),
    })),
    ...selectedBodyStyles.map((v) => ({
      type: "bodyStyle",
      value: v,
      label: getOptionLabel(bodyStyleOptions, v),
    })),
    ...selectedTransmissions.map((v) => ({
      type: "transmission",
      value: v,
      label: getOptionLabel(transmissionOptions, v),
    })),
    ...selectedColors.map((v) => ({
      type: "color",
      value: v,
      label: getOptionLabel(colorOptions, v),
    })),
    ...selectedFuelTypes.map((v) => ({
      type: "fuelType",
      value: v,
      label: getOptionLabel(fuelTypeOptions, v),
    })),
    ...selectedDrivetrains.map((v) => ({
      type: "drivetrain",
      value: v,
      label: getOptionLabel(drivetrainOptions, v),
    })),
    ...selectedCylinders.map((v) => ({
      type: "cylinders",
      value: v,
      label: getOptionLabel(cylindersOptions, v),
    })),
    ...selectedPassengers.map((v) => ({
      type: "passengers",
      value: v,
      label: getOptionLabel(passengersOptions, v),
    })),
  ];

  const removeFilter = (type: string, value: string) => {
    switch (type) {
      case "condition":
        toggleInList(value, setSelectedConditions);
        break;
      case "make":
        toggleMake(value);
        break;
      case "model":
        toggleModel(value);
        break;
      case "bodyStyle":
        toggleInList(value, setSelectedBodyStyles);
        break;
      case "transmission":
        toggleInList(value, setSelectedTransmissions);
        break;
      case "color":
        toggleInList(value, setSelectedColors);
        break;
      case "fuelType":
        toggleInList(value, setSelectedFuelTypes);
        break;
      case "drivetrain":
        toggleInList(value, setSelectedDrivetrains);
        break;
      case "cylinders":
        toggleInList(value, setSelectedCylinders);
        break;
      case "passengers":
        toggleInList(value, setSelectedPassengers);
        break;
      default:
        break;
    }
  };

  const resetAllFilters = () => {
    setKeywordSearch("");
    setPriceFilterMode("price");
    setPriceRange(DEFAULT_PRICE);
    setPaymentRange(DEFAULT_PAYMENT);
    setYearRange(DEFAULT_YEAR);
    setKmRange(DEFAULT_KM);

    setPriceRangeDraft(DEFAULT_PRICE);
    setPaymentRangeDraft(DEFAULT_PAYMENT);
    setYearRangeDraft(DEFAULT_YEAR);
    setKmRangeDraft(DEFAULT_KM);

    setSelectedConditions([]);
    setSelectedMakes([]);
    setSelectedModels([]);
    setSelectedBodyStyles([]);
    setSelectedTransmissions([]);
    setSelectedColors([]);
    setSelectedFuelTypes([]);
    setSelectedDrivetrains([]);
    setSelectedCylinders([]);
    setSelectedPassengers([]);
    setSelectedCompareCars([]);

    setSortBy("make-asc");
    setViewMode("grid");
    setCurrentPage(1);

    navigate("/car-inventory");
  };

  return (
    <div className="inventory-page min-h-screen bg-gray-50">
      <section className="relative pt-20 min-h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/images/inventory-hero-bg.jpg"
            alt="Luxury car showroom"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center scroll-reveal">
          <Badge className="mb-6 bg-red-600/20 text-red-400 border-red-600/30 px-4 py-2">
            <Car className="w-4 h-4 mr-2" />
            Premium Pre-Owned Vehicles
          </Badge>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
            FIND YOUR <span className="text-red-500">PERFECT</span> RIDE
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-8">
            Explore our curated collection of quality pre-owned vehicles. Each
            car is rigorously inspected and ready for the road.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <div className="flex items-center gap-2 text-white/80">
              <Shield className="w-5 h-5 text-red-500" />
              <span>150-Point Inspection</span>
            </div>
            <div className="flex items-center gap-2 text-white/80">
              <CreditCard className="w-5 h-5 text-red-500" />
              <span>Flexible Financing</span>
            </div>
          </div>
        </div>
      </section>

      <main
        className={`pt-28 ${compareDockVisible ? "pb-64 md:pb-40" : "pb-16"}`}
      >
        <div ref={inventoryStartRef} className="w-full px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-8 scroll-reveal">
            <div>
              <h2 className="text-3xl font-bold text-gray-900">
                VEHICLES IN <span className="text-red-600">INVENTORY</span>
              </h2>
              <p className="text-gray-600 mt-1">
                <span className="font-semibold text-gray-900">
                  {inventoryPagination.total}
                </span>{" "}
                Items Matching
              </p>
            </div>

            {activeFilters.length > 0 && (
              <div className="flex flex-wrap items-center gap-2">
                {activeFilters.map((filter, idx) => (
                  <Badge
                    key={`${filter.type}-${filter.value}-${idx}`}
                    variant="secondary"
                    className="bg-red-100 text-red-700 hover:bg-red-200 cursor-pointer flex items-center gap-1"
                    onClick={() => removeFilter(filter.type, filter.value)}
                  >
                    {filter.label}
                    <X className="w-3 h-3" />
                  </Badge>
                ))}
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={resetAllFilters}
                  className="text-red-600 hover:text-red-700"
                >
                  Clear All
                </Button>
              </div>
            )}

            <div className="flex items-center gap-4">
              <div className="relative">
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2 pr-10 text-gray-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                >
                  <option value="make-asc">Make Name: A to Z</option>
                  <option value="make-desc">Make Name: Z to A</option>
                  <option value="price-asc">Price: Low to High</option>
                  <option value="price-desc">Price: High to Low</option>
                  <option value="year-asc">Year: Low to High</option>
                  <option value="year-desc">Year: High to Low</option>
                  <option value="km-asc">Km: Low to High</option>
                  <option value="km-desc">Km: High to Low</option>
                </select>
                <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" />
              </div>

              <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
                <button
                  onClick={() => setViewMode("grid")}
                  className={`flex items-center gap-2 px-4 py-2 transition-colors ${
                    viewMode === "grid"
                      ? "bg-red-600 text-white"
                      : "bg-white text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  <Grid3X3 className="w-4 h-4" />
                  Grid
                </button>
                <button
                  onClick={() => setViewMode("list")}
                  className={`flex items-center gap-2 px-4 py-2 transition-colors ${
                    viewMode === "list"
                      ? "bg-red-600 text-white"
                      : "bg-white text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  <List className="w-4 h-4" />
                  List
                </button>
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-6 xl:gap-5">
            <aside
              className={`lg:w-[224px] xl:w-[236px] 2xl:w-[248px] flex-shrink-0 scroll-reveal ${
                showFilters ? "" : "hidden lg:block"
              }`}
            >
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="p-4 border-b border-gray-200 flex items-center justify-between">
                  <h3 className="font-semibold text-gray-900 flex items-center gap-2">
                    <Filter className="w-5 h-5" />
                    Filters
                  </h3>
                  <div className="flex gap-2">
                    <button
                      onClick={() => setShowFilters(false)}
                      className="text-sm text-gray-500 hover:text-gray-700 lg:hidden"
                    >
                      <X className="w-5 h-5" />
                    </button>
                  </div>
                </div>

                <ScrollArea className="h-[calc(100vh-300px)] lg:h-auto">
                  <div className="p-4 space-y-6">
                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">
                        Keyword Search
                      </h4>
                      <div className="relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                        <Input
                          placeholder="Search by Year, Make, Model, Trim, Stock #"
                          value={keywordSearch}
                          onChange={(e) => setKeywordSearch(e.target.value)}
                          className="pl-10"
                        />
                      </div>
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">
                        {priceFilterMode === "price"
                          ? "Price"
                          : "Weekly Payment"}
                      </h4>

                      <div className="bg-gray-100 rounded-lg px-3 py-2 text-center mb-3">
                        {priceFilterMode === "price" ? (
                          <span className="text-sm text-gray-600">
                            ${priceRangeDraft[0].toLocaleString()} to $
                            {priceRangeDraft[1].toLocaleString()}
                          </span>
                        ) : (
                          <span className="text-sm text-gray-600">
                            ${paymentRangeDraft[0]} to ${paymentRangeDraft[1]}
                            /wk
                          </span>
                        )}
                      </div>

                      {priceFilterMode === "price" ? (
                        <Slider
                          value={priceRangeDraft}
                          onValueChange={(v) =>
                            setPriceRangeDraft(v as [number, number])
                          }
                          onValueCommit={(v) =>
                            setPriceRange(v as [number, number])
                          }
                          min={0}
                          max={150000}
                          step={1000}
                          className="mb-3"
                        />
                      ) : (
                        <Slider
                          value={paymentRangeDraft}
                          onValueChange={(v) =>
                            setPaymentRangeDraft(v as [number, number])
                          }
                          onValueCommit={(v) =>
                            setPaymentRange(v as [number, number])
                          }
                          min={0}
                          max={300}
                          step={5}
                          className="mb-3"
                        />
                      )}

                      <div className="flex gap-4 text-sm">
                        <button
                          type="button"
                          onClick={() => setPriceFilterMode("price")}
                          className={
                            priceFilterMode === "price"
                              ? "text-red-600 font-medium"
                              : "text-gray-500 hover:text-red-600"
                          }
                        >
                          Filter by Price
                        </button>
                        <span className="text-gray-300">|</span>
                        <button
                          type="button"
                          onClick={() => setPriceFilterMode("payment")}
                          className={
                            priceFilterMode === "payment"
                              ? "text-red-600 font-medium"
                              : "text-gray-500 hover:text-red-600"
                          }
                        >
                          Filter by Payment
                        </button>
                      </div>
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">Year</h4>
                      <div className="bg-gray-100 rounded-lg px-3 py-2 text-center mb-3">
                        <span className="text-sm text-gray-600">
                          {yearRangeDraft[0]} to {yearRangeDraft[1]}
                        </span>
                      </div>
                      <Slider
                        value={yearRangeDraft}
                        onValueChange={(v) =>
                          setYearRangeDraft(v as [number, number])
                        }
                        onValueCommit={(v) =>
                          setYearRange(v as [number, number])
                        }
                        min={2010}
                        max={CURRENT_YEAR}
                        step={1}
                      />
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">
                        Kilometres
                      </h4>
                      <div className="bg-gray-100 rounded-lg px-3 py-2 text-center mb-3">
                        <span className="text-sm text-gray-600">
                          {kmRangeDraft[0].toLocaleString()}KM to{" "}
                          {kmRangeDraft[1].toLocaleString()}KM
                        </span>
                      </div>
                      <Slider
                        value={kmRangeDraft}
                        onValueChange={(v) =>
                          setKmRangeDraft(v as [number, number])
                        }
                        onValueCommit={(v) => setKmRange(v as [number, number])}
                        min={0}
                        max={200000}
                        step={5000}
                      />
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">Make</h4>
                      <div className="space-y-2">
                        {makeOptions.map((make) => (
                          <label
                            key={make.value}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <Checkbox
                              checked={selectedMakes.includes(make.value)}
                              onCheckedChange={() => toggleMake(make.value)}
                            />
                            <span className="text-gray-700 flex-1">
                              {make.label}
                            </span>
                            <span className="text-gray-400 text-sm">
                              {makeCounts[make.label]
                                ? `(${makeCounts[make.label]})`
                                : ""}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">Model</h4>
                      <div className="space-y-2">
                        {filteredModelOptions.map((model) => (
                          <label
                            key={model.value}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <Checkbox
                              checked={selectedModels.includes(model.value)}
                              onCheckedChange={() => toggleModel(model.value)}
                            />
                            <span className="text-gray-700">{model.label}</span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">
                        Body Style
                      </h4>
                      <div className="space-y-2">
                        {bodyStyleOptions.map((style) => (
                          <label
                            key={style.value}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <Checkbox
                              checked={selectedBodyStyles.includes(style.value)}
                              onCheckedChange={() =>
                                toggleInList(style.value, setSelectedBodyStyles)
                              }
                            />
                            <span className="text-gray-700">{style.label}</span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">
                        Transmission
                      </h4>
                      <div className="space-y-2">
                        {transmissionOptions.map((trans) => (
                          <label
                            key={trans.value}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <Checkbox
                              checked={selectedTransmissions.includes(
                                trans.value,
                              )}
                              onCheckedChange={() =>
                                toggleInList(
                                  trans.value,
                                  setSelectedTransmissions,
                                )
                              }
                            />
                            <span className="text-gray-700">{trans.label}</span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">
                        Exterior Color
                      </h4>
                      <div className="space-y-2">
                        {colorOptions.map((color) => (
                          <label
                            key={color.value}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <Checkbox
                              checked={selectedColors.includes(color.value)}
                              onCheckedChange={() =>
                                toggleInList(color.value, setSelectedColors)
                              }
                            />
                            <span className="text-gray-700">{color.label}</span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">
                        Fuel Type
                      </h4>
                      <div className="space-y-2">
                        {fuelTypeOptions.map((fuel) => (
                          <label
                            key={fuel.value}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <Checkbox
                              checked={selectedFuelTypes.includes(fuel.value)}
                              onCheckedChange={() =>
                                toggleInList(fuel.value, setSelectedFuelTypes)
                              }
                            />
                            <span className="text-gray-700">{fuel.label}</span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">
                        Condition
                      </h4>
                      <div className="space-y-2">
                        {conditionOptions.map((condition) => (
                          <label
                            key={condition.value}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <Checkbox
                              checked={selectedConditions.includes(
                                condition.value,
                              )}
                              onCheckedChange={() =>
                                toggleInList(
                                  condition.value,
                                  setSelectedConditions,
                                )
                              }
                            />
                            <span className="text-gray-700">
                              {condition.label}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">
                        Drive Train
                      </h4>
                      <div className="space-y-2">
                        {drivetrainOptions.map((dt) => (
                          <label
                            key={dt.value}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <Checkbox
                              checked={selectedDrivetrains.includes(dt.value)}
                              onCheckedChange={() =>
                                toggleInList(dt.value, setSelectedDrivetrains)
                              }
                            />
                            <span className="text-gray-700">{dt.label}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">
                        Cylinders
                      </h4>
                      <div className="space-y-2">
                        {cylindersOptions.map((cyl) => (
                          <label
                            key={cyl.value}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <Checkbox
                              checked={selectedCylinders.includes(cyl.value)}
                              onCheckedChange={() =>
                                toggleInList(cyl.value, setSelectedCylinders)
                              }
                            />
                            <span className="text-gray-700">{cyl.label}</span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <Separator />

                    <div>
                      <h4 className="font-medium text-gray-900 mb-3">
                        Passengers
                      </h4>
                      <div className="space-y-2">
                        {passengersOptions.map((passenger) => (
                          <label
                            key={passenger.value}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <Checkbox
                              checked={selectedPassengers.includes(
                                passenger.value,
                              )}
                              onCheckedChange={() =>
                                toggleInList(
                                  passenger.value,
                                  setSelectedPassengers,
                                )
                              }
                            />
                            <span className="text-gray-700">
                              {passenger.label}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <Button
                      variant="outline"
                      className="w-full border-red-600 text-red-600 hover:bg-red-50"
                      onClick={resetAllFilters}
                    >
                      Reset Filters
                    </Button>
                  </div>
                </ScrollArea>
              </div>
            </aside>

            <div className="min-w-0 flex-1 scroll-reveal flex flex-col">
              {inventoryError && (
                <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                  {inventoryError}
                </div>
              )}
              <button
                onClick={() => setShowFilters(!showFilters)}
                className="lg:hidden mb-4 flex items-center gap-2 bg-white border border-gray-300 px-4 py-2 rounded-lg"
              >
                <Filter className="w-4 h-4" />
                Filters
              </button>

              {inventoryLoading ? (
                <div className="text-center py-16 bg-white rounded-xl">
                  <Car className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Loading vehicles...
                  </h3>
                  <p className="text-gray-600">
                    Please wait while inventory is loading.
                  </p>
                </div>
              ) : inventoryCars.length === 0 ? (
                <div className="text-center py-16 bg-white rounded-xl">
                  <Car className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    No vehicles found
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Try adjusting your filters to see more results.
                  </p>
                  <Button
                    onClick={resetAllFilters}
                    className="bg-red-600 hover:bg-red-700"
                  >
                    Reset Filters
                  </Button>
                </div>
              ) : (
                <>
                  <div
                    className={`inventory-cards-stage ${cardsAnimationClass}`}
                  >
                    <div
                      className={
                        viewMode === "grid"
                          ? "inventory-cards-grid"
                          : "space-y-6"
                      }
                    >
                      {visibleCars.map((car) => {
                        const isSold = car.isSold;
                        const isCompareSelected = selectedCompareCars.includes(
                          car.id,
                        );
                        const isCompareDisabled =
                          selectedCompareCars.length >= 2 && !isCompareSelected;

                        return (
                          <div
                            key={car.id}
                            className={`car-card ${
                              viewMode === "list"
                                ? "inventory-card--list flex flex-col md:flex-row"
                                : "inventory-card--grid"
                            } bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-300 ${
                              isSold ? "inventory-card--sold" : ""
                            } ${isCompareSelected ? "ring-2 ring-red-500 shadow-xl shadow-red-100" : ""}`}
                          >
                            <div className="car-image-container relative">
                              {car.image ? (
                                <img
                                  src={car.image}
                                  alt={getCarTitle(car) || "Vehicle"}
                                  className="inventory-car-image"
                                />
                              ) : (
                                <div className="inventory-car-image inventory-car-image--placeholder bg-gray-100" />
                              )}
                              <div className="absolute top-3 left-3 flex gap-2">
                                {car.isGoodPrice && car.tagLabel && (
                                  <Badge className="bg-green-500 text-white">
                                    <Star className="w-3 h-3 mr-1 fill-current" />
                                    {car.tagLabel}
                                  </Badge>
                                )}
                              </div>
                              {isSold && (
                                <div
                                  className="inventory-sold-ribbon"
                                  aria-label="Sold out"
                                >
                                  <span className="inventory-sold-ribbon__shine" />
                                  <span className="inventory-sold-ribbon__text">
                                    SOLD OUT
                                  </span>
                                </div>
                              )}
                            </div>

                            <div
                              className={`p-5 ${viewMode === "list" ? "md:w-2/3" : ""}`}
                            >
                              <h3 className="text-lg font-bold text-gray-900 mb-3">
                                {getCarTitle(car)}
                              </h3>

                              <div className="flex items-start justify-between gap-4 mb-4">
                                <div className="min-w-0">
                                  <p className="text-sm text-gray-500 min-h-[20px]">
                                    {getInstallmentHeading(car.installmentType)}
                                  </p>

                                  <p className="text-[1.35rem] md:text-[1.45rem] font-bold text-red-600 leading-none min-h-[32px]">
                                    {car.installmentAmount !== null ? (
                                      <>
                                        ${formatCurrency(car.installmentAmount)}
                                        {getInstallmentSuffix(
                                          car.installmentType,
                                        ) && (
                                          <span className="text-sm font-normal text-gray-500">
                                            {getInstallmentSuffix(
                                              car.installmentType,
                                            )}
                                          </span>
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </p>

                                  <p className="text-xs text-gray-400 min-h-[18px]">
                                    {getInstallmentMeta(
                                      car.installmentPercentage,
                                      car.installmentDuration,
                                    )}
                                  </p>
                                </div>
                                <div className="text-right shrink-0">
                                  <p className="text-sm text-gray-500">
                                    Dealer Price
                                  </p>
                                  <p className="text-[1.35rem] md:text-[1.45rem] font-bold text-gray-900 leading-none">
                                    {car.price !== null
                                      ? `$${formatCurrency(car.price)}`
                                      : ""}
                                  </p>
                                  <p className="text-xs text-gray-400">+ Tax</p>
                                </div>
                              </div>

                              <div className="grid grid-cols-2 gap-2 text-sm mb-4">
                                <div className="flex items-center gap-2 text-gray-600">
                                  <Car className="spec-icon w-4 h-4 text-gray-400" />
                                  <span className="truncate">
                                    {car.stockNumber || ""}
                                  </span>
                                </div>

                                <div className="flex items-center gap-2 text-gray-600">
                                  <Gauge className="spec-icon w-4 h-4 text-gray-400" />
                                  <span>
                                    {car.km !== null
                                      ? `${formatNumber(car.km)} KM`
                                      : ""}
                                  </span>
                                </div>

                                <div className="flex items-center gap-2 text-gray-600">
                                  <Fuel className="spec-icon w-4 h-4 text-gray-400" />
                                  <span>{car.fuelType || ""}</span>
                                </div>

                                <div className="flex items-center gap-2 text-gray-600">
                                  <Settings className="spec-icon w-4 h-4 text-gray-400" />
                                  <span>{car.bodyStyle || ""}</span>
                                </div>

                                <div className="flex items-center gap-2 text-gray-600 col-span-2">
                                  <Settings2 className="spec-icon w-4 h-4 text-gray-400" />
                                  <span>{car.transmission || ""}</span>
                                </div>
                              </div>

                              <div className="space-y-2">
                                <Link
                                  to={`/vehicle-details/${car.id}`}
                                  className={`w-full flex items-center justify-between border px-4 py-3 rounded-lg transition-colors ${
                                    isSold
                                      ? "border-gray-300 bg-gray-200 text-gray-600 hover:bg-gray-300"
                                      : "border-gray-900 bg-gray-900 text-white hover:bg-gray-800"
                                  }`}
                                >
                                  <span className="font-medium">
                                    View More Details
                                  </span>
                                  <ArrowRight className="w-4 h-4" />
                                </Link>
                              </div>

                              <div className="mt-4 inventory-card-bottom-actions">
                                {!isSold && car.carfxUrl ? (
                                  <a
                                    href={car.carfxUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inventory-history-badge inventory-history-badge--link"
                                    aria-label={`Open vehicle history report for ${getCarTitle(car)}`}
                                  >
                                    <img
                                      src="/images/car-fax-logo.jpeg"
                                      alt="Vehicle History"
                                      className="inventory-history-badge__image"
                                      loading="lazy"
                                      decoding="async"
                                    />
                                  </a>
                                ) : (
                                  <div className="inventory-history-badge inventory-history-badge--hidden" />
                                )}

                                <label
                                  className={`inventory-compare-toggle inventory-compare-toggle--full ${
                                    isCompareSelected ? "is-active" : ""
                                  } ${isCompareDisabled ? "is-disabled" : ""} ${
                                    isSold
                                      ? "inventory-compare-toggle--sold"
                                      : ""
                                  }`}
                                >
                                  <Checkbox
                                    checked={isCompareSelected}
                                    onCheckedChange={() =>
                                      handleCompareToggle(car.id)
                                    }
                                    disabled={isCompareDisabled}
                                    className="border-gray-300 data-[state=checked]:border-red-600 data-[state=checked]:bg-red-600"
                                  />
                                  <span>Compare</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {totalPages > 1 && (
                    <div className="inventory-pagination-wrap">
                      <nav
                        className="inventory-pagination"
                        aria-label="Inventory pagination"
                      >
                        <div className="inventory-pagination__shell">
                          <button
                            type="button"
                            className="inventory-pagination__arrow"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1 || isPaginating}
                            aria-label="Go to previous page"
                          >
                            <ChevronLeft className="w-8 h-8" />
                          </button>

                          <div className="inventory-pagination__center">
                            {prevPage ? (
                              <button
                                type="button"
                                className="inventory-pagination__peek inventory-pagination__peek--prev"
                                onClick={() => handlePageChange(prevPage)}
                                disabled={isPaginating}
                                aria-label={`Go to page ${prevPage}`}
                              >
                                {prevPage}
                              </button>
                            ) : (
                              <span
                                className="inventory-pagination__peek inventory-pagination__peek--ghost"
                                aria-hidden="true"
                              >
                                0
                              </span>
                            )}

                            <div
                              className="inventory-pagination__current"
                              aria-current="page"
                            >
                              {currentPage}
                            </div>

                            {nextPage ? (
                              <button
                                type="button"
                                className="inventory-pagination__peek inventory-pagination__peek--next"
                                onClick={() => handlePageChange(nextPage)}
                                disabled={isPaginating}
                                aria-label={`Go to page ${nextPage}`}
                              >
                                {nextPage}
                              </button>
                            ) : (
                              <span
                                className="inventory-pagination__peek inventory-pagination__peek--ghost"
                                aria-hidden="true"
                              >
                                0
                              </span>
                            )}
                          </div>

                          <button
                            type="button"
                            className="inventory-pagination__arrow"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={
                              currentPage === totalPages || isPaginating
                            }
                            aria-label="Go to next page"
                          >
                            <ChevronRight className="w-8 h-8" />
                          </button>
                        </div>

                        <div className="inventory-pagination__status">
                          Page <span>{currentPage}</span> of{" "}
                          <span>{totalPages}</span>
                        </div>
                      </nav>
                    </div>
                  )}
                </>
              )}

              <p className="text-xs text-gray-500 mt-8 text-center">
                Please contact the dealership for verification of any
                information listed herein. Due to human error and other possible
                complications, we cannot guarantee the accuracy of the
                information included herein, despite all reasonable attempts
                being made to ensure its accuracy.
              </p>
            </div>
          </div>
        </div>
      </main>

      {compareDockVisible && (
        <div className="inventory-compare-dock">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="inventory-compare-dock__inner">
              <div className="inventory-compare-dock__meta">
                <span className="inventory-compare-dock__eyebrow">
                  Vehicle Compare
                </span>
                <h3 className="inventory-compare-dock__title">
                  {selectedCompareCarsData.length === 1
                    ? "Select one more vehicle"
                    : "Ready to compare"}
                </h3>
                <p className="inventory-compare-dock__text">
                  You can compare up to 2 vehicles at a time.
                </p>
              </div>

              <div className="inventory-compare-dock__chips">
                {selectedCompareCarsData.map((car) => (
                  <div key={car.id} className="inventory-compare-chip">
                    <div className="inventory-compare-chip__thumb">
                      {car.image ? (
                        <img
                          src={car.image}
                          alt={getCarTitle(car) || "Vehicle"}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="w-full h-full bg-gray-100" />
                      )}
                    </div>

                    <div className="inventory-compare-chip__content">
                      <p className="inventory-compare-chip__name">
                        {getCarTitle(car)}
                      </p>
                      <p className="inventory-compare-chip__price">
                        {car.price !== null
                          ? `$${formatCurrency(car.price)}`
                          : ""}
                      </p>
                    </div>

                    <button
                      type="button"
                      className="inventory-compare-chip__remove"
                      onClick={() => removeComparedCar(car.id)}
                      aria-label={`Remove ${getCarTitle(car)} from compare`}
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ))}

                {selectedCompareCarsData.length < 2 && (
                  <div className="inventory-compare-placeholder">
                    <span>+ Select 1 more vehicle</span>
                  </div>
                )}
              </div>

              {selectedCompareCarsData.length === 2 && (
                <Link
                  to={compareLink}
                  className="inventory-compare-dock__button"
                >
                  Compare Now
                  <ArrowRight className="w-4 h-4" />
                </Link>
              )}
            </div>
          </div>
        </div>
      )}

      {showScrollTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className={`scroll-to-top fixed right-6 md:right-8 w-12 h-12 bg-red-600 text-white rounded-full shadow-lg flex items-center justify-center hover:bg-red-700 transition-all duration-300 z-50 ${
            compareDockVisible
              ? "inventory-scroll-top--with-dock"
              : "bottom-6 md:bottom-8"
          }`}
        >
          <ChevronUp className="w-6 h-6" />
        </button>
      )}
    </div>
  );
}
